import { useRef, useState } from "react";
import InputError from "@atoms/inputs/InputError/InputError";
import { cn } from "@util/helpers";

/** Input field - text field */
const TextField = ({
  placeholder,
  name,
  type = "text",
  variantClassName,
  onHandleChange,
  errorMessage,
}: TextFields): React.ReactElement => {
  const [value, setValue] = useState<string>("");
  const timeoutRef = useRef<NodeJS.Timeout | null>(null);
  const inputRef = useRef<HTMLInputElement>(null);

  const handleChange = (value: string) => {
    if (!onHandleChange) return;
    if (value.length < 3) return;
    if (timeoutRef.current) clearTimeout(timeoutRef.current);

    timeoutRef.current = setTimeout(() => {
      if (onHandleChange) onHandleChange(value);
    }, 300);
  };

  return (
    <div
      data-testid="text-field-component"
      className={cn("w-full", variantClassName?.container)}
    >
      <input
        placeholder={placeholder}
        name={name}
        type={type}
        className={cn(
          "w-full p-4",
          variantClassName?.input,
          variantClassName?.placeholder,
          variantClassName?.focus,
          {
            [variantClassName?.errorBorder || "border-red"]: errorMessage,
          }
        )}
        autoComplete="off"
        ref={inputRef}
        onChange={(e) => {
          setValue(e.target.value);
        }}
        onBlur={() => {
          if (!onHandleChange) return;
          handleChange(value);
        }}
        value={value}
      />

      {errorMessage ? <InputError error={errorMessage} /> : null}
    </div>
  );
};

export default TextField;
